// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import { withRouter } from "react-router-dom";
import throttle from "lodash/throttle";
import Media from "react-media";

import { TradeButton as TradeButtonRaw } from "../UnitedHeader";

const TradeButton = styled(TradeButtonRaw)`
  position: fixed;
  top: 97.5%;
  left: 50%;
  transform: translateY(-97.5%);
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
  z-index: 8;
  opacity: 1;
  transition: all 0.3s ease-in-out;

  @media (min-width: 960px) {
    margin-left: -480px;

    :hover {
      box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);
    }
  }

  ${props =>
    props.isHidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `};
`;

const Button = styled.button`
  position: fixed;
  top: 97.5%;
  left: 50%;
  transform: translateY(-97.5%);
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 57px;
  width: 57px;
  height: 57px;
  border: none;
  border-radius: 50%;
  background-color: ${props => props.theme.accent};
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
  appearance: none;
  cursor: pointer;
  z-index: 8;
  opacity: 1;
  transition: all 0.3s ease-in-out;

  @media (min-width: 960px) {
    margin-left: 480px;

    :hover {
      background-color: #fd9600;
      box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);
    }
  }

  @media (max-width: 959px) {
    left: 100%;
    transform: translate(-100%, -250%);
    margin-left: -10px;
  }

  ${props =>
    props.isHidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `};
`;

type Props = {
  onClick?: Function,
  history: Object,
  hideTrade?: boolean
};

type State = {
  isHidden: boolean
};

class ToTopButton extends React.Component<Props, State> {
  state = {
    isHidden: true
  };

  handleTradeClick = () => {
    const topNode = document.querySelectorAll(".js-anchor")[0];
    if (topNode) {
      this.props.history.replace(`#${topNode.id}`);
    }

    window.scrollTo(0, 0);
  };

  handleScroll = () => {
    const { isHidden } = this.state;

    if (window.pageYOffset > 73) {
      if (isHidden === true) {
        this.setState({
          isHidden: false
        });
        return;
      }
    } else {
      if (isHidden === false) {
        this.setState({
          isHidden: true
        });
      }
      return;
    }
  };

  throttleScroll = throttle(() => this.handleScroll(), 150);

  componentDidMount() {
    window.addEventListener("scroll", this.throttleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttleScroll);
  }

  render() {
    return (
      <React.Fragment>
        {!this.props.hideTrade && (
          <Media
            query="(min-width: 960px)"
            render={() => (
              <TradeButton
                isHidden={this.state.isHidden}
                onClick={this.handleTradeClick}
                isFixedButton
              />
            )}
          />
        )}
        <Button
          isHidden={this.state.isHidden}
          onClick={this.props.onClick}
          isFixedButton
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="28px">
            <path
              fillRule="evenodd"
              fill="rgb(255, 255, 255)"
              d="M23.573,11.136 L13.515,1.078 C12.929,0.492 11.979,0.492 11.393,1.078 L1.335,11.136 C0.749,11.722 0.749,12.672 1.335,13.258 C1.921,13.844 2.871,13.844 3.457,13.258 L10.986,5.729 L10.986,25.819 C10.986,26.648 11.658,27.320 12.486,27.320 C13.315,27.320 13.987,26.648 13.987,25.819 L13.987,5.794 L21.451,13.258 C22.037,13.844 22.987,13.844 23.573,13.258 C24.159,12.672 24.159,11.722 23.573,11.136 Z"
            />
          </svg>
        </Button>
      </React.Fragment>
    );
  }
}

export default withRouter(ToTopButton);



// WEBPACK FOOTER //
// ./src/components/Helpdesk/ToTopButton.js